import React, { FC, MouseEvent, useCallback } from 'react';
import ButtonOutlined from '../../../../../common/components/presentation/Button/ButtonOutlined';
import calculateButtonsStyles from './calculateButtonStyles';
import Translation from '../../../../../gqlCommon/components/translation/Translation';

export interface ICalculateButtonProps {
  disabled: boolean;
  onFinanceCalculate: () => void;
}

const CalculateButton: FC<ICalculateButtonProps> = ({ disabled, onFinanceCalculate }) => {
  const styles = calculateButtonsStyles();

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      onFinanceCalculate();
    },
    [onFinanceCalculate],
  );

  return (
    <ButtonOutlined
      isButtonDisabled={disabled}
      data-test={'finance_values:button:calculate'}
      className={styles.financeButton}
      onClick={handleClick}
      buttonText={
        <Translation
          id="trans__configurator__customise_page_finance_details__calculate_CTA"
          defaultMessage="Calculate"
        />
      }
    />
  );
};

export default CalculateButton;
